// extracted by mini-css-extract-plugin
export var container = "_tt-0";
export var table = "_tt-2";
export var tableWrapper = "_tt-1";